let organsFlag = [];
const getAllOrgans = (response) => {
	organsFlag = [];

	response?.forEach((item) => {
		organsFlag.push({
			value: item.id,
			text: item.nombre,
			text2:
				item.estatus === 'A' ? 'Activo' : item.estatus === 'I' ? 'Inactivo' : '',
			spanColor:
				item.estatus === 'A' ? 'primary' : item.estatus === 'I' ? 'danger' : '',
		});

		item?.organos?.map((subItem) => getNSubOrgans(subItem, 2));
	});

	return organsFlag;
};

const getNSubOrgans = (subItem, line) => {
	organsFlag.push({
		value: subItem.id,
		text: Array(line).join('-') + subItem.nombre,
		text2:
			subItem.estatus === 'A'
				? 'Activo'
				: subItem.estatus === 'I'
				? 'Inactivo'
				: '',
		spanColor:
			subItem.estatus === 'A' ? 'primary' : subItem.estatus === 'I' ? 'danger' : '',
	});

	subItem?.organos?.map((sItem) => getNSubOrgans(sItem, line + 1));
};

export { getAllOrgans };
